import '../../sass/blocks/custom/interactive/_accordion.scss'
require('../../js/blocks/accordion.js');